// extracted by mini-css-extract-plugin
export default {"heading":"MessageDialog_heading__tEgz-","subHeading":"MessageDialog_subHeading__MKrgI","button":"MessageDialog_button__dc2g0","primary":"MessageDialog_primary__U86PC"};